import type { useInterventionTemplateJsonEditorProps } from "./intervention-template-json-editor.type";
import type { InterventionTemplateNode } from "@/entities/intervention-template";

import { useEffect, useState } from "react";

import { useUpdate } from "@/hooks/queries";
import { useApiErrorHandler } from "@/modules/api-errors";
import { useSaveBar } from "@/modules/app-save-bar";

export const useInterventionTemplateJsonEditor = ({
  template,
}: useInterventionTemplateJsonEditorProps) => {
  const { setIsDirty } = useSaveBar();
  const { onError } = useApiErrorHandler();
  const mutation = useUpdate("interventionTemplates", template.id);

  const [templates, setTemplates] = useState<InterventionTemplateNode[]>(
    template.templates ?? []
  );

  useEffect(() => {
    setTemplates(template.templates ?? []);
  }, [template]);

  const handleSave = () => {
    mutation.mutate(
      { templates: templates },
      {
        onSuccess: () => setIsDirty(false),
        onError,
      }
    );
  };

  const handleCancel = () => {
    setTemplates(template.templates ?? []);
    setIsDirty(false);
  };

  const onSchemaChange = (
    newSchema: InterventionTemplateNode[] | null,
    isRegistrable: boolean
  ) => {
    setTemplates(newSchema ?? []);
    isRegistrable && setIsDirty(true);
  };

  return {
    templates,
    isPending: mutation.isPending,
    isEditable: template.is_editable ?? false,
    onSchemaChange,
    handleCancel,
    handleSave,
  };
};
